<template lang="pug">
div
  b-modal#create-event(
    title='Create an Event',
    :hide-footer='true',
    ref="createEventModal",
    @hide='clearEvent()',
    @show='show()')
    .page.container
      .row.body
        .col-12.section-1(v-if='section === 1')
          // @TODO: Make component
          .monster-section
            .title.d-flex.justify-content-center
              h5 Choose Your Sprite
              b-tooltip(:triggers="tooltipTriggers", placement="right", target="info-1", title="Every Event you create needs a Sprite to participate. Sprites can take on as many events as you want.")
              span#info-1.info i
            .card-item.row.align-items-center
              .col-4
                sprite-render.sprite.d-flex.align-items-center(:sprite='selectedSprite')
              .col-8
                strong {{ selectedSprite.name }}
                .level Level {{ selectedSprite.level || 0 }}
                .d-flex.align-items-center
                  .hp-bar-wrap.d-flex
                    .label.d-flex.align-items-center.justify-content-center hp
                    .progress-wrap.d-flex.align-items-center
                      .white-background.d-flex.align-items-center.justify-content-center
                        .progress-bar
                  .hp-amount 50 / 50
            .monster-options.row.d-flex.justify-content-center
              .monster.col-2(v-for='sprite in userSprites',
                @click='selectedSprite = sprite',
                :class='{selected: (selectedSprite._id && selectedSprite._id === sprite._id) || (!selectedSprite._id && selectedSprite.name === sprite.name)}')
                sprite-render(:sprite='sprite')
          // @TODO: Make component
          .boss-section
            .title.d-flex.justify-content-center
              h5 Select your difficulty
              b-tooltip(:triggers="tooltipTriggers", placement="right", target="info-2", title="Choose your Event’s difficulty. The higher the difficulty level, the more HP the monster will have.  Be careful, if you don’t complete a task before the countdown is up, the monster you’re battling will strike! When your Sprite’s or the monster’s HP hits zero the Event is complete.")
              span#info-2.info i
            .difficulty.d-flex.justify-content-center
              b-dropdown.dropdown-component(:text='difficulty | toTitleCase')
                b-dropdown-item-button(@click='difficulty = "normal"', :class="{active: difficulty === 'normal'}") Normal
                b-dropdown-item-button(@click='difficulty = "hard"', :class="{active: difficulty === 'hard'}") Hard
                b-dropdown-item-button(@click='difficulty = "nightmare"', :class="{active: difficulty === 'nightmare'}") Nightmare
            b-tooltip(target="random-enemeny", title="Once you’ve chosen your Event’s Difficulty, a monster will be chosen at random to battle your Sprite.")
            #random-enemeny.card-item.row.align-items-center
              .col-3
                .sprite.question.d-flex.justify-content-center.align-items-center
                  img(src='../../assets/question.svg')
              .col-9
                strong Random
                .level
                .d-flex.align-items-center
                  .hp-bar-wrap.d-flex
                    .label.d-flex.align-items-center.justify-content-center hp
                    .progress-wrap.d-flex.align-items-center
                      .white-background.d-flex.align-items-center.justify-content-center
                        .progress-bar
                  .hp-amount {{ bossHp }} / {{ bossHp }}
        .col-12.section-2(v-if='section === 2')
          .title.d-flex.justify-content-center
            h5 Choose an Integration
            b-tooltip(:triggers="tooltipTriggers", placement="right", target="info-3", title="This is how we'll track your progress. When you select an integration, actions you take will empower your sprite to damage the monster and reward you with experience too.")
            span#info-3.info i
          // @TODO: Share with integration box
          .row.integration-row.d-flex.justify-content-center
            .col-12.col-md-4(v-for='integration in integrations', v-if='integration.id === "habitica" || providers.Github')
              .integration(
                :key='integration.id',
                @click='selectedIntegration = integration',
                :class="{selected: selectedIntegration.id === integration.id}")
                  img(src='../../assets/habitica.svg', v-if='integration.id === "habitica"')
                  img(src='../../assets/github.svg', v-else)
          .title.d-flex.justify-content-center
            h5 Customize Settings
            b-tooltip(:triggers="tooltipTriggers", placement="right", target="info-4", title="You can adjust what activities each event will monitor. Mix and match settings to customize events to suit your needs.")
            span#info-4.info i
          .row
            .col-12.option(v-for='(option, key) in integrationOptions[selectedIntegration.id]', :key='key')
              strong.float-left {{option.label}}
              switches.float-right(v-model="option.value", theme="custom", color="green")
      .row.footer
        .col-12.col-md-4
          .btn.btn-primary.float-left.back(v-if='this.section !== 1', @click='back()') Back
        .col-12.col-md-4.page-items
          .circle(:class="{active: this.section === 1}")
          .circle(:class="{active: this.section === 2}")
        .col-12.col-md-4
          .btn.btn-primary.float-right.next(v-if='this.section !== numberOfPages', @click='next()') Next
          .btn.btn-primary.float-right.create(v-if='this.section === numberOfPages && !loading', @click='create()') Create
          .btn.btn-primary.float-right.create(v-if='loading') Loading...
</template>

<style lang="scss">
  #create-event {
    .modal-content {
      border-radius: 16px;
      border: none;
    }

    .modal-dialog {
      // width: 588px;
      border-radius: 16px;
      background-color: #ffffff;

      .modal-header {
        border-radius: 16px 16px 0 0;
        background-image: linear-gradient(to right, #9bc75a, #3ba5a8);
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: 1px;
        text-align: center;
        color: #ffffff;

        h5.modal-title {
          text-align: center;
          margin: 0 auto;
          margin-left: 8em;
        }
      }

      button {
        color: #fff;
        opacity: 1;
        text-shadow: none;
      }
    }

    /* Switch */

    .vue-switcher div {
      height: 20px;
    }

    .vue-switcher div:after {
      height: 12px;
      width: 12px;
      margin-left: -15px;
      top: 4px;
    }

    .vue-switcher--unchecked div:after {
      left: 18px;
    }

    .vue-switcher-theme--custom {
      &.vue-switcher-color--green {
        div {
          background-color: lighten(#9bc75a, 10%);

          &:after {
            // for the circle on the switch
            background-color: #fff;
          }
        }

        &.vue-switcher--unchecked {
          div {
            background-color: #a1a39e;

            &:after {
              background-color: #fff;
            }

          }
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  .page {
    h5 {
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: 1px;
      text-align: center;
      color: #363734;
      margin-bottom: .5rem;
    }

    p {
      text-align: center;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #6c6d69;

    }
  }

  .sprite img {
    max-height: 80px;
  }

  .question img {
    display: block;
    width: 23px;
    height: 56px;
    margin-top: -10px;
  }

  .body {
    margin-bottom: 2em;

    .monster {
      text-align:center;
      margin-right: 1em;
      margin-bottom: .5rem;
      width: 64px;
      height: 64px;
      opacity: 1;
      border-radius: 4px;
      border: dotted 2px #e7e9e4;

      display: flex;         /* NEW, Spec - Firefox, Chrome, Opera */

      justify-content: center;
      align-items: center;
    }

    .monster img {
      max-height: 35px;
      margin: 0 auto;
      display: block;
    }

    .monster:hover {
      cursor: pointer;
    }

    .monster.selected {
      border: solid 2px #9bc75a;
    }

    .section-1 {
      .card-item {
        padding: 1rem .5rem;
        border-radius: 16px;
        background-color: #f7f8f6;
        margin: 0 auto;
        text-align: left;
      }

      .sprite {
        width: 80px;
        height: 80px;
        border-radius: 8px;
        background-color: #ffffff;
        margin: 0 auto;
      }

      .level {
        margin-bottom: .2rem;
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        color: #a1a39e;
        min-height: 15px;
      }

      .hp-bar-wrap {
        width: 193px;
        height: 16px;
        border-radius: 4px;
        background-color: #e7e9e4;

        .label {
          width: 27px;
          height: 16px;
          border-radius: 4px 0 0px 4px;
          background-color: #a1a39e;
          text-transform: uppercase;
          font-size: 10px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          color: #ffffff;
        }

        .progress-wrap {
          height: 100%;
          width: 166px;

          .white-background {
            background-color: #ffffff;
            height: 8px;
            width: 158px;
            margin: 0 auto;
            border-radius: 4px;
          }

          .progress-bar {
            width: 154px;
            height: 4px;
            border-radius: 4px;
            background-color: #e14455;
          }
        }
      }

      .hp-amount {
        margin-left: .5rem;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: #a1a39e;
      }

      .monster-options {
        padding: 2em;
      }

      .boss {
        max-height: 150px;
      }

      .boss img {
        max-height: 150px;
        margin: 0 auto;
        display: block;
      }

      .enemy img {
        height: 50px;
      }

      .difficulty {
        margin-top: .5rem;
        margin-bottom: 1rem;

        button {
          background: #fff;
        }
      }
    }

    .section-2 {
      .integration {
        height: 164px;
        margin-bottom: 1em;
        border-radius: 8px;
        background-color: #ffffff;
        box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);

        display: flex;
        justify-content: center;
        align-items: center;
      }

      .integration.selected {
        border: 1px solid green;
      }

      .integration-row {
        margin-bottom: 2rem;
      }

      .option {
        width: 100%;
        padding: .8rem;
        min-height: 40px;
      }

      .option:nth-child(odd) {
        background-color: #f7f8f6;
      }
    }

    .section-3 {
      strong {
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        color: #363734;
      }
    }
  }

  .page-items {
    text-align: center;

    .circle {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #e7e9e4;
      display: inline-block;
      margin-right: .2rem;
    }

    .circle.active {
      background-color: #9bc75a;
    }
  }

  .next, .back, .create  {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 2px;
    text-align: center;
    color: #9bc75a;
    background: none;
    border: none;
    text-transform: uppercase;
  }

  .back {
    color: #a1a39e;
  }

  .back::before {
    background: url('../../assets/back.svg') no-repeat;
    content: "";
    width: 7px;
    height: 10px;
    background-position: center;
    display: inline-block;
    vertical-align: initial;
    margin-right: .5rem;
  }

  .next:after {
    background: url('../../assets/next.svg') no-repeat;
    content: "";
    width: 7px;
    height: 10px;
    background-position: center;
    display: inline-block;
    vertical-align: initial;
    margin-left: .5rem;
  }

  .info {
    width: 16px;
    height: 16px;
    background-color: #3ba5a8;
    border-radius: 50%;
    text-align: center;
    color: #fff;
    font-size: 10px;
    margin-left: .5rem;
    padding-top: .1rem;
    margin-top: .1rem;
  }
</style>

<script>
import Switches from 'vue-switches';
import SpriteRender from '../monsters/SpriteRender';
import blockchainSprites from '../../mixins/blockchainSprites';
import { bossOptions } from '../../lib/boss';

export default {
  name: 'EventCreate',
  mixins: [blockchainSprites],
  components: {
    Switches,
    SpriteRender,
  },
  data() {
    return {
      loading: false,
      numberOfPages: 2,
      section: 1,
      name: '',
      difficulty: 'normal',
      selectedSprite: {},
      bossOptions,
      selectedIntegration: {},
      integrations: [
        {
          name: 'Habitica',
          id: 'habitica',
          img: '../../assets/habitica.svg',
        },
        {
          name: 'Github',
          id: 'github',
          img: '../../assets/github.svg',
        },
      ],
      // @TODO: Share
      integrationOptions: {
        github: {
          pushEvent: {
            label: 'Push Commits',
            value: true,
          },
          comments: {
            label: 'Comments',
            value: true,
          },
          closeIssue: {
            label: 'Close Issue',
            value: true,
          },
          openIssue: {
            label: 'Open Issue',
            value: true,
          },
          completeMilestone: {
            label: 'Complete Milestone',
            value: true,
          },
          subscribeToRepo: {
            label: 'Subscribe to Repo',
            value: true,
          },
          submitPullRequest: {
            label: 'Submit Pull Request',
            value: true,
          },
        },
        habitica: {
          habitis: {
            label: 'Habits',
            value: true,
          },
          dailies: {
            label: 'Dailies',
            value: true,
          },
          todos: {
            label: 'To-dos',
            value: true,
          },
          checklist: {
            label: 'Checklist items',
            value: true,
          },
          // levelup: {
          //   label: 'Level up',
          //   value: true,
          // },
          startQuest: {
            label: 'Start a Quest',
            value: true,
          },
          // completeQuest: {
          //   label: 'Complete a Quest',
          //   value: true,
          // },
          creatTask: {
            label: 'Creating a task',
            value: true,
          },
          // hatchPet: {
          //   label: 'Hatching a pet',
          //   value: true,
          // },
          // raisingMount: {
          //   label: 'Raising a mount',
          //   value: true,
          // },
        },
      },
    };
  },
  async mounted() {
    await this.getSpritesFromChain();
    this.selectedIntegration = this.integrations[0];
  },
  // @TODO: Share
  filters: {
    toTitleCase(str) {
      return str.replace(
        /\w\S*/g,
        (txt) => {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        },
      );
    },
  },
  computed: {
    providers() {
      return this.$store.state.integrations;
    },
    allEvents() {
      return this.$store.state.events;
    },
    // @TODO: Share
    activeEvents() {
      return this.allEvents.filter((event) => {
        const defeated = event.eventOptions.status === 'defeat';
        return !event.completed && !defeated;
      });
    },
    bossHp() {
      if (this.difficulty === 'hard') return 200;
      if (this.difficulty === 'nightmare') return 300;
      return 100;
    },
    tooltipTriggers() {
      if (this.allEvents.length > 0) return 'click';
      return 'click hover';
    },
  },
  methods: {
    show() {
      this.selectedSprite = this.favoriteMonster;
      this.showToolstips();
    },
    showToolstips() {
      if (this.allEvents.length > 0) return;
      this.$nextTick().then(() => {
        setTimeout(() => {
          const info1 = document.querySelector('#info-1');
          const info2 = document.querySelector('#info-2');
          const info3 = document.querySelector('#info-3');
          const info4 = document.querySelector('#info-4');
          if (info1) info1.click();
          if (info2) info2.click();
          if (info3) info3.click();
          if (info4) info4.click();
        }, 1000);
      });
    },
    back() {
      if (this.section === 1) return;
      this.section -= 1;
      this.showToolstips();
    },
    next() {
      if (this.section === this.numberOfPages) return;
      this.section += 1;
      this.showToolstips();
    },
    randomBetween(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    getBossIndex() {
      if (this.difficulty === 'hard') return this.randomBetween(3, 5);
      if (this.difficulty === 'nightmare') return this.randomBetween(6, 8);
      return this.randomBetween(0, 2);
    },
    async create() {
      const activityEventWithIntegration = this.activeEvents.find(e => e.eventOptions.integration === this.selectedIntegration.id);
      if (activityEventWithIntegration) {
        alert('You already have an active event with this integration.');
        return;
      }

      this.loading = true;

      const intOptions = this.integrationOptions[this.selectedIntegration.id];
      const flatIntOptions = Object.keys(intOptions)
        .reduce((acc, curr) => {
          acc[curr] = intOptions[curr].value;
          return acc;
        }, {});

      const enemyIndex = this.getBossIndex();

      const eventOptions = {
        difficulty: this.difficulty,
        boss: this.bossOptions[enemyIndex].id,
        bossHealth: this.bossHp,
        integration: this.selectedIntegration.id,
        integratonOptions: flatIntOptions,
        sprite: this.selectedSprite._id,
        spriteName: this.selectedSprite.name,
        spriteFreeType: this.selectedSprite.freeType,
        spriteHealth: 50,
      };

      if (!this.selectedSprite.free) {
        eventOptions.spriteTokenId = this.selectedSprite.tokenId;
      }

      try {
        const event = await this.$store.dispatch('createEvent', {
          name: this.name || 'default',
          privacy: 'private',
          eventOptions,
        });

        this.$store.state.events.unshift(event);
      } catch (e) {
        this.loading = false;
        return alert(e.response.data.message);
      }

      this.loading = false;

      window.amplitude.getInstance().logEvent('CREATE_EVENT');

      return this.$refs.createEventModal.hide();
    },
    clearEvent() {
      const selectedIntegration = this.integrationOptions[this.selectedIntegration.id];
      if (selectedIntegration) {
        Object.keys(selectedIntegration)
          .forEach((key) => {
            const option = selectedIntegration[key];
            option.value = true;
          });
      }

      this.selectedIntegration = this.integrations[0];
      this.section = 1;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/events/EventCreate.vue